import { gql } from '@apollo/client';

export const DisableCurrentUserTFAMutation = gql`
    mutation disableCurrentUserTFA($totpCode: String!) {
        disableCurrentUserTFA(totpCode: $totpCode)
    }
`;
